import Box from "@mui/material/Box";
import moment from 'moment'
import Stack from "@mui/material/Stack";
import SelectMonths from "../select/selectMonths/SelectMonths";
import SelectYears from "../select/selectYears/SelectYears";
import DaysDatePicker from "../days/Days";
import React from 'react';
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import {useTranslation} from "react-i18next";
import SelectHours from "@ui/datePicker/containers/selectDateFixed/select/selectHours/SelectHours";
import SelectMinutes from "@ui/datePicker/containers/selectDateFixed/select/selectMinutes/SelectMinutes";

const selectDateSx = {
    root: {
        paddingTop: '15px'
    },
    button: {
        textTransform: 'inherit'
    },
    day: {
        margin: '0 auto'
    }
}


const SelectDateControlled = ({
                                  value,
                                  onSave,
                                  closeModalFn,
                                  onChange,
                                  hasTime,


                              }) => {

    const {t} = useTranslation()

    const onChangeMonths = (month) => {
        if (onChange) {
            onChange(moment(value)?.month(month).format())
        }
    }
    const onChangeYear = (year) => {
        if (onChange) {
            onChange(moment(value)?.year(year).format())
        }
    }

    const onChangeHours = (year) => {
        if (onChange) {
            onChange(moment(value)?.hour(year).format())
        }
    }

    const onChangeMinutes = (minutes) => {
        if (onChange) {
            const newValue = moment(value)?.minute(minutes).format()
            onChange(newValue)
        }
    }

    const save = () => {
        if (onSave) {
            onSave(moment(value)?.format())
        }
        if (closeModalFn) {
            closeModalFn()
        }
    }

    return (
        <Stack
            sx={selectDateSx.root}
            gap={2}
        >
            <Stack
                gap={2}
                direction={{
                    xs: 'column',
                    lg: 'row'
                }}
            >
                <SelectMonths
                    currentMonth={moment(value)?.month()}
                    onChange={onChangeMonths}
                />

                <SelectYears
                    currentYear={moment(value)?.year()}
                    onChange={onChangeYear}
                />
            </Stack>



            {/*<ActionFixedDatePicker*/}
            {/*    value={value}*/}
            {/*    onChange={onChange}*/}
            {/*/>*/}

            <Box
                sx={selectDateSx.day}
            >
                <DaysDatePicker
                    value={value}
                    onChange={onChange}
                />
            </Box>

            {hasTime &&
                <Stack
                    gap={1}
                    direction={'row'}
                >
                    <SelectHours
                        value={moment(value)?.hour()}
                        onChange={onChangeHours}
                    />

                    <SelectMinutes
                        value={moment(value)?.minutes()}
                        onChange={onChangeMinutes}
                    />
                </Stack>}

            <Stack
                direction={'row'}
                flexWrap={'wrap'}
                gap={1}
                justifyContent={'flex-end'}
            >
                <ButtonCustom
                    variant={'outlined'}
                    onClick={closeModalFn}
                    label={t('back')}
                    sx={selectDateSx.button}
                />
                <ButtonCustom
                    variant={'contained'}
                    label={t('ok')}
                    onClick={save}
                    sx={selectDateSx.button}
                />
            </Stack>
        </Stack>
    )
};

export default SelectDateControlled;